import {IContentManager} from './IContentManager';
import axios from 'axios';
import {searchIn, templateString, genUID} from './Utils';
import * as queryString from 'query-string';
// const queryString = require('query-string');
/*
Configuration needed is as follows:
{
projectName: 'project name in squidex',
identity: { // make sure the user is a read only client
  client_id: 'provided by squidex',
  client_secret: 'provided by squidex'
},
baseUrl: 'there is a default, but if we need to change the squidex server'
identityUrl: 'path from baseUrl in order to identify user as squidex won\'t let any content to be loaded unless connected'
contentUrl: 'path structure (templated), in order to fetch the right data set'
}
*/

const PAGINATION_SIZE = 200; // maximum pagination allowed by squidex

export class ContentManager implements IContentManager {
  _auth = null; // will contain identity for squidex to allow the following dataset requests
  _dataSets = {} //will contain already fetched datasets
  _ready = false; //will be set to true when initialization is done
  _buffer = []; //buffering requests before initialization is done (keeping order in requests)
  _config = null; // will contain the config

  constructor(public config:any = {}) {
    this._ready = false;
    this._config = {
      projectName: 'playground',
      identity: {
        client_id: '',
        client_secret: '',
        scope: 'squidex-api',
        grant_type: 'client_credentials'
      },
      baseUrl: 'https://jeux-cms.ap-bbox.com/',
      identityUrl: 'identity-server/connect/token',
      contentUrl: 'api/content/{{projectName}}/{{dataSet}}',
      ...config
    };

    this.initialize();
  }

  async initialize():Promise<void> {
    let response = await axios({
      method: 'POST',
      baseURL: this._config.baseUrl,
      url: this._config.identityUrl,
      data: queryString.stringify({
          ...this._config.identity
      }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });

    this._auth = response.data;
    this._ready = true;
  }

  getAuth(): string {
    return `${this._auth.token_type} ${this._auth.access_token}`;
  }

  waitForReady():Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this._ready)
        return resolve();

      let timerId = setInterval(() => {
        if (this._ready) {
            clearInterval(timerId);
            resolve();
        }
      }, 10);
    });
  }

  public async fullLoad(dataSet:string):Promise<any> {
    await this.waitForReady();

    if (this._dataSets[dataSet]) {
      return this._dataSets[dataSet];
    }
    let endReached = false;
    let offset = 0;
    let firstRequestHandled = false;
    let cummulatedItems = [];
    let data = {

    };
    while (!endReached) {
      let page = await this.paginatedLoad(dataSet, offset, PAGINATION_SIZE);
      cummulatedItems.push(...page.items);
      if (!firstRequestHandled) {
        data = page;
        firstRequestHandled = true;
      }

      if (page.items.length < PAGINATION_SIZE) {
        endReached = true;
      } else {
        offset += PAGINATION_SIZE;
      }
    }

    data = {
      ...data,
      items: cummulatedItems
    }

    this._dataSets[dataSet] = data;

    return data;
  }

  public async paginatedLoad(dataSet:string, offset: number, size: number = PAGINATION_SIZE): Promise<any> {
    let path = templateString(this._config.contentUrl, {
      projectName: this._config.projectName,
      dataSet
    });
    let headers = {
      'Authorization': this.getAuth()
    };

    let response = await axios({
      method: 'GET',
      baseURL: this._config.baseUrl,
      url: path + `?$skip=${offset}&$top=${size}`,
      headers
    });

    return response.data;
  }

  public async getData(dataSet:string, path:string): Promise<any> {
    let data: any = await this.fullLoad(dataSet);
    return searchIn(path, data);
  }
}
